import React from 'react';
import { weakKey } from '../../../../utilities/weakKey';
import { FooterTypes } from './footerTypes';
import { useVariant } from './hooks/VariantContext';
import { footerConstants } from './helpers/constants';
import { getTextColor } from './helpers/ColorSelectorHelper';
import { useThemeContext } from './hooks/themeContext';

export const FooterQuickLinks: Function = ({
  navLinks,
}: FooterTypes.TNavLinks) => {
  const currentVariant = useVariant();
  const currTheme = useThemeContext();
  const limiter =
    currentVariant === 'footer-2'
      ? navLinks.slice(0, footerConstants.maxNavLinksCount)
      : navLinks;

  return limiter.map(({ NavLinkText, navLinkDropDown, RenderAs, linkTo }) => {
    const FooterVariantOneList = () => {
      return (
        <li
          key={weakKey(navLinkDropDown)}
          className={`footerLinks has-text-${getTextColor(currTheme)}`}
        >
          <RenderAs
            to={linkTo}
            className={`has-text-${getTextColor(currTheme)}`}
          >
            {NavLinkText}
          </RenderAs>
        </li>
      );
    };
    const FooterVariantsTwoAndThreeList = () => {
      return (
        <p
          key={weakKey(navLinkDropDown)}
          className={
            currentVariant === 'footer-3'
              ? `footerLinksVariantThree mb-3`
              : `footerLinksVariantTwo mb-3`
          }
        >
          <RenderAs
            to={linkTo}
            className={`has-text-${getTextColor(currTheme)}`}
          >
            {NavLinkText}
          </RenderAs>
        </p>
      );
    };
    const FooterQuickLinksHelper = () => {
      return currentVariant === 'footer-1'
        ? FooterVariantOneList()
        : FooterVariantsTwoAndThreeList();
    };

    return FooterQuickLinksHelper();
  });
};
